import {
  Asset,
  Element,
  Language,
  Project,
  Scene,
  Settings,
} from '@marketertechnologies/property-picker';
import { useEffect } from 'react';

export type CallbackArgs =
  | {
      unit: Element;
      lang?: Language;
      activeScene: string;
      activeAngle?: string | number;
      floorplans: Asset[];
      gallery: Asset[];
      scenes: Scene[];
      settings: Settings;
      project: Project;
    }
  | undefined;

export const useModal = (callback: (args: CallbackArgs) => void) => {
  useEffect(() => {
    const handler = (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data);

        if (data.type === 'modal:open') {
          callback(data.value);
        }
      } catch {
        // Ignore parsing errors as we are receiving a lot of messages that are not json data
      }
    };

    window.addEventListener('message', handler);

    return () => window.removeEventListener('message', handler);
  }, [callback]);

  const handleClose = () => {
    window.parent.postMessage(
      JSON.stringify({
        type: 'modal:close',
      }),
      '*',
    );
    callback(undefined);
  };

  return { handleClose };
};
